// Author Shi Wen Long
// Date 2021-08-25 12:04:20

class SithMesPrdSdProjectWbs {
constructor({
        id = null,
        projectDefinition = '',
        levelCode = '',
        wbs = '',
        decription = '',
        remark = ''}
= {}) {
    this.id = id;
    this.projectDefinition = projectDefinition;
    this.levelCode = levelCode;
    this.wbs = wbs;
    this.decription = decription;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdSdProjectWbs();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.grid.projectDefinition',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'levelCode',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.grid.levelCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.grid.wbs',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'decription',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.grid.decription',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    projectDefinitionFilter : "",
    levelCodeFilter : "",
    wbsFilter : "",
    decriptionFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'projectDefinitionFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.filter.projectDefinition',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'levelCodeFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.filter.levelCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbsFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.filter.wbs',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'decriptionFilter',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.filter.decription',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'projectDefinition',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.entity.projectDefinition',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'levelCode',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.entity.levelCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'wbs',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'decription',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.entity.decription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdSdProjectWbs.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesPrdSdProjectWbs, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
